import { render, staticRenderFns } from "./coursePackets.vue?vue&type=template&id=bca5ffe4&scoped=true&"
import script from "./coursePackets.vue?vue&type=script&lang=js&"
export * from "./coursePackets.vue?vue&type=script&lang=js&"
import style0 from "./coursePackets.vue?vue&type=style&index=0&id=bca5ffe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca5ffe4",
  null
  
)

export default component.exports